export default "__VITE_ASSET__Dmat1K3d__"